export class DocumentQueryDTO {
  userId!: string;
  name?: string;
  category?: string;
  subCategory?: string;
  dateStart?: number;
  dateEnd?: number;
  lastRef?: string;
  sendEmailData?: boolean;
}
